/**
 * An abstract interface for storage adapters
 */
class StorageInterface {
}
export default StorageInterface;
